import { render } from "./zixun.vue?vue&type=template&id=447154e0&scoped=true"
import script from "./zixun.vue?vue&type=script&lang=js"
export * from "./zixun.vue?vue&type=script&lang=js"

import "./zixun.vue?vue&type=style&index=0&id=447154e0&lang=scss&scoped=true"

import exportComponent from "E:\\Project\\UGit\\heronlink\\web\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-447154e0"]])

export default __exports__